import styled from "styled-components";
import { colors } from "../../../common/ui/globalColors";

export const StyledNotes = styled.div`
  .top-bar {
    justify-content: flex-start;
  }

  .notes-wrapper {
      border: 1px solid ${colors.semiTransparentColors.blue};
      border-radius: 28px;
      padding: 33px 24px;
      margin-top: 25px;
  }

  .comment {
      padding: 8px 0;
      text-align: ${({ ltr }) => ltr ? 'left' : 'right'};
      color: ${colors.semiTransparentColors.grayBlue};
      font-size: 14px;
      line-height: 20px;
  
      &:not(:last-child) {
          border-bottom: 1px solid ${colors.semiTransparentColors.purple};
      }
  
      p {
        margin: 0;
      }
  
      &.is-my {
        color: ${props => props.theme.main};
  
        .name {
          color: ${props => props.theme.main};
        }
      }
  }

  .data {
      font-size: 12px;
      line-height: 23px;
      margin-bottom: 4px;

      span {
        margin-right: ${({ ltr }) => ltr ? '10px' : ''};
        margin-left: ${({ ltr }) => ltr ? '' : '10px'};
      }
  }
  
  .name {
      font-size: 14px;
      color: ${colors.textColors.black};
      font-weight: bold;
  }

  .add-comment {
      padding: 0;
      padding-top: 15px;
      margin: 10px 30px 0;
      border-top: 1px solid ${colors.semiTransparentColors.blue};
  }
`